interface RGB {
  r: number
  g: number
  b: number
}

export function getAverageRGB(imgEl: HTMLImageElement): { rgb: RGB; hex: string } {
  const blockSize = 5 // only visit every 5 pixels
  const defaultRGB: RGB = { r: 0, g: 0, b: 0 } // default RGB value
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  let data: ImageData
  let i = -4
  const rgb: RGB = { r: 0, g: 0, b: 0 }
  let count = 0

  if (!context) {
    return { rgb: defaultRGB, hex: `#${rgb.r.toString(16)}${rgb.g.toString(16)}${rgb.b.toString(16)}` }
  }

  const height = (canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height)
  const width = (canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width)

  context.drawImage(imgEl, 0, 0)

  try {
    data = context.getImageData(0, 0, width, height)
  } catch (_error) {
    console.log('_error', _error)
    return { rgb: defaultRGB, hex: `#${rgb.r.toString(16)}${rgb.g.toString(16)}${rgb.b.toString(16)}` }
  }

  const length = data.data.length

  while ((i += blockSize * 4) < length) {
    const r = data.data[i] || defaultRGB.r
    const g = data.data[i + 1] || defaultRGB.g
    const b = data.data[i + 2] || defaultRGB.b

    // Check if the pixel is not black or white
    if (!(r <= 10 && g <= 10 && b <= 10) && !(r >= 245 && g >= 245 && b >= 245)) {
      rgb.r += r
      rgb.g += g
      rgb.b += b
      count++
    }
  }

  // Avoid division by zero if no valid pixels are found
  if (count > 0) {
    rgb.r = Math.floor(rgb.r / count)
    rgb.g = Math.floor(rgb.g / count)
    rgb.b = Math.floor(rgb.b / count)
  } else {
    return { rgb: defaultRGB, hex: `#${rgb.r.toString(16)}${rgb.g.toString(16)}${rgb.b.toString(16)}` } // Return default if no pixels are counted
  }

  return { rgb, hex: `#${rgb.r.toString(16)}${rgb.g.toString(16)}${rgb.b.toString(16)}` }
}
